(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var hdr = document.querySelector('.hdr-over');
    if (!hdr) return;
    // the hero needs to know how tall the header is to pad its text back down
    var setH = function () {
      document.documentElement.style.setProperty('--hdr-h', hdr.offsetHeight + 'px');
    };
    setH();
    window.addEventListener('resize', setH);

    var onScroll = function () {
      hdr.classList.toggle('hdr-solid', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
